import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { MaxShipping } from '../../../../../typings'
import { ReviewProps } from './constants'
import { messages } from './messages'

export function MaxShippingRecap(props: ReviewProps) {
  const { config } = props
  const { formatCurrency } = useNumbers()

  if (!config.benefit || !config.scope) return null

  const { benefit, scope } = config

  return (
    <FormattedMessage
      {...messages.maxShipping}
      values={{
        b: (content) => <Text variant="action1">{content}</Text>,
        discount: formatCurrency((benefit as MaxShipping).value),
        applyTo: scope.applyTo,
      }}
    />
  )
}
